import React from "react"
import Loader from "../Loader/index.js"
const RoundedButton = ({
  title,
  children,
  onClick,
  variant = "primary",
  className,
  isLoading,
}) => {
  const buttonVariant = {
    primary: "bg-primary text-white font-[600]",
    secondary:
      "bg-white text-greyText boxShadow font-[400]",
  }
  return (
    <div>
      <button
        onClick={onClick}
        className={`${buttonVariant[variant]} text-nowrap flex justify-center items-center text-[20px]  rounded-full leading-[24px] h-[52px] w-[52px] ${className}`}
      >
        {isLoading ? <Loader /> : title ? title : children}
      </button>
    </div>
  )
}

export { RoundedButton }
